import React, {
  memo,
  useMemo,
} from 'react';

import { Typography } from 'antd';

import CustomTag from '../../../../components/CustomTag/CustomTag';
import ProfileItem from '../../../../components/ProfileItem/ProfileItem';
import { useTheme } from '../../../../context/ThemeProvider';
import {
  DEFAULT_AVATAR,
  DELETED_USER,
} from '../../../../shared/data';
import { useAppNavigate } from '../../../../shared/hooks';
import {
  checkIfCurrentLoggedInUser,
  getReadableDateAndTimeFormat,
} from '../../../../shared/utils';
import { ROUTES } from '../../../../types/routes';
import {
  ITQServiceRequestUser,
  TQServiceRequestStatusType,
  TQServiceRequestVisibilityType,
} from '../../../../types/tqConnectTypes/service-requests';
import { SERVICE_REQUEST_STATUS_COLORS } from '../../constants';

interface Props {
  requestedBy: ITQServiceRequestUser;
  requestedTo?: ITQServiceRequestUser;
  totalResponses: number;
  status: TQServiceRequestStatusType;
  createdAt: string;
  visibility?: TQServiceRequestVisibilityType;
  insideDetailsPage?: boolean;
}

const ServiceRequestCardStats: React.FC<Props> = ({
  requestedBy,
  requestedTo,
  status,
  createdAt,
  insideDetailsPage = false,
}) => {
  const navigate = useAppNavigate();
  const { colors: COLORS } = useTheme();

  const { avatarSize, titleSize, textSize } = useMemo(() => {
    return {
      avatarSize: insideDetailsPage ? 32 : 24,
      titleSize: insideDetailsPage ? 14 : 13,
      textSize: insideDetailsPage ? 13 : 12,
    };
  }, [insideDetailsPage]);

  const goToUserProfile = (userId: string) => {
    if (!userId) return;

    navigate(ROUTES.USER_PROFILE, { userId });
  };

  return (
    <>
      <div className="service-request-card__stats card__stats">
        <div className="stats__text-info">
          <ProfileItem
            title={
              <>
                <Typography.Text
                  style={{
                    marginRight: 4,
                    fontWeight: 600,
                    fontSize: titleSize,
                    color: COLORS.TEXT2,
                  }}>
                  {checkIfCurrentLoggedInUser(requestedBy?._id)
                    ? 'You'
                    : requestedBy?.name || DELETED_USER}
                </Typography.Text>{' '}
                <br />
                <Typography.Text
                  type="secondary"
                  style={{ cursor: 'auto' }}
                  onClick={(e) => e?.stopPropagation()}>
                  requested {requestedTo ? 'help from' : ''}
                </Typography.Text>
                {requestedTo ? null : (
                  <Typography.Text
                    type="secondary"
                    style={{
                      fontSize: textSize,
                      cursor: 'auto',
                    }}
                    onClick={(e) => e?.stopPropagation()}>
                    &nbsp;•&nbsp;
                    {getReadableDateAndTimeFormat(createdAt)}
                    {/* {timeAgo(moment().toDate())} */}
                  </Typography.Text>
                )}
              </>
            }
            avatar={requestedBy?.profilePicUrl || DEFAULT_AVATAR}
            avatarSize={avatarSize}
            titleStyle={{
              fontWeight: 400,
              fontSize: textSize,
              color: COLORS.TEXT3,
              // display: 'inline-flex',
              alignItems: 'center',
            }}
            contentStyle={{
              marginLeft: 8,
            }}
            style={{
              alignItems: 'center',
            }}
            onClick={() => goToUserProfile(requestedBy?._id)}
          />
        </div>
        {requestedTo ? (
          <div className="stats__text-info">
            <ProfileItem
              title={
                <>
                  <Typography.Text
                    style={{
                      fontWeight: 600,
                      fontSize: titleSize,
                      color: COLORS.TEXT2,
                      cursor: 'pointer',
                    }}>
                    {checkIfCurrentLoggedInUser(requestedTo?._id)
                      ? 'You'
                      : requestedTo?.name || DELETED_USER}
                  </Typography.Text>
                  <Typography.Text
                    type="secondary"
                    style={{
                      fontSize: textSize,
                      cursor: 'auto',
                    }}
                    onClick={(e) => e?.stopPropagation()}>
                    &nbsp;•&nbsp;
                    {getReadableDateAndTimeFormat(createdAt)}
                  </Typography.Text>
                </>
              }
              avatar={requestedTo?.profilePicUrl || DEFAULT_AVATAR}
              avatarSize={avatarSize}
              titleStyle={{
                fontWeight: 400,
                fontSize: textSize,
                color: COLORS.TEXT3,
                display: 'inline-flex',
                alignItems: 'center',
              }}
              contentStyle={{
                marginLeft: 8,
              }}
              style={{
                alignItems: 'center',
              }}
              onClick={() => goToUserProfile(requestedTo?._id)}
            />
          </div>
        ) : null}

        {/* <div className="stats__right">
          {totalResponses > 0 && visibility === 'public' ? (
            <Typography.Text className="stats__item" type="secondary">
              <TMIcon
                name="people-outline"
                size={18}
                color={COLORS.ICON}
                style={{ flexShrink: 0 }}
              />
              {numFormatterInUnit(totalResponses)}{' '}
              {getSingularOrPlural(totalResponses, 'Help')} offered
            </Typography.Text>
          ) : null}
        </div> */}
      </div>
      <CustomTag
        className="tq-service-card__status"
        color={SERVICE_REQUEST_STATUS_COLORS[status]}
        style={{
          margin: 0,
          textTransform: 'none',
          fontSize: 12,
          fontWeight: 500,
        }}>
        {status.toTitleCase()}
      </CustomTag>
    </>
  );
};

export default memo(ServiceRequestCardStats);
